<section>
  <kl-robocall-tile [postDetails]="dialogData?.data?.postDetails" [fullView]="true" ></kl-robocall-tile>
  <div fxLayout="row" fxLayoutAlign="flex-end " class="mt-3 mr-3">
    <button (click)="ok()" color="primary" mat-flat-button>Download report</button>
  </div>
</section>